/**
 * TanStack Query hooks for `day-parting-schedule-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dayPartingScheduleTargetingQueryKeys,
	type CreateDayPartingScheduleTargetingBody,
	type ListDayPartingScheduleTargetingResponse,
	type DayPartingScheduleTargetingRow,
} from "./api";

export function useDayPartingScheduleTargetingList(): UseQueryResult<ListDayPartingScheduleTargetingResponse, Error> {
	return useQuery({
		queryKey: dayPartingScheduleTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useDayPartingScheduleTargetingCreate(): UseMutationResult<DayPartingScheduleTargetingRow, Error, CreateDayPartingScheduleTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dayPartingScheduleTargetingQueryKeys.all });
		},
	});
}

export function useDayPartingScheduleTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dayPartingScheduleTargetingQueryKeys.all });
		},
	});
}
